(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-activation', {
            parent: 'entity',
            url: '/user-activation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.userActivation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-activation/user-activations.html',
                    controller: 'UserActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userActivation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-activation-detail', {
            parent: 'user-activation',
            url: '/user-activation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'teJHipsterApp.userActivation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-activation/user-activation-detail.html',
                    controller: 'UserActivationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userActivation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserActivation', function($stateParams, UserActivation) {
                    return UserActivation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-activation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-activation-detail.edit', {
            parent: 'user-activation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-activation.new', {
            parent: 'user-activation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                activated: false,
                                lastSyncTime: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('user-activation');
                });
            }]
        })
        .state('user-activation.edit', {
            parent: 'user-activation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-dialog.html',
                    controller: 'UserActivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-activation.delete', {
            parent: 'user-activation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-activation/user-activation-delete-dialog.html',
                    controller: 'UserActivationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserActivation', function(UserActivation) {
                            return UserActivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-activation', null, { reload: 'user-activation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
